import { isContentfulEntry, type EntryWithBrandList } from '@/types/contentful';

/**
 * Pure utility: checks whether a Contentful entry is visible to the current brand.
 * Handles both simplified brandList format (string[]) and full object format.
 */
export function isVisibleToCurrentBrand(item: EntryWithBrandList): boolean {
  const brandCode = process.env.NEXT_PUBLIC_BRAND;
  const rawBrandList = (item?.fields as { brandList?: unknown } | undefined)?.brandList;

  // No brand restriction → visible to all brands
  if (!rawBrandList) return true;

  // Normalize single reference or array of references
  const brandRefs = Array.isArray(rawBrandList) ? rawBrandList : [rawBrandList];

  // Empty array → visible to all brands
  if (brandRefs.length === 0) return true;

  // Brand restriction exists, but current brand is not configured → fail closed
  if (!brandCode) return false;

  // Handle both string array (new simplified format) and full object format (legacy)
  return brandRefs.some((brand) => {
    // New simplified format: ["GLD", "HRZ", "CAS"]
    if (typeof brand === 'string') {
      return brand === brandCode;
    }

    // Legacy format: [{ sys: {...}, fields: { brandCode: "GLD" } }]
    if (isContentfulEntry(brand)) {
      return brand.fields?.brandCode === brandCode;
    }

    return false;
  });
}

// Use only in server contexts - will be undefined in client contexts
export const isReducedBrandSite = process.env.REDUCED_BRAND_SITE === 'true';
